import CreditCounter from '@components/student-dashboard/credit-system/counter-cta'
import { useSessionContext } from '@contexts/session'
import { SUBJECTS } from '@lib/constants/billing'
import { CClient } from '@common/utils'
import { useEffect, useState } from 'react'

const CreditsDisplay = () => {
  const { student, totalCodingCredits, totalMathCredits } = useSessionContext()
  const [enrolledSubjects, setEnrolledSubjects] = useState<string[]>([])

  useEffect(() => {
    const fetchEnrolledSubjects = async () => {
      try {
        const url = `/api/v1/students/${student.id}/dashboards/enrolled_subjects/`
        const response = await CClient(url)

        if (!response.ok) {
          throw new Error(
            `Error fetching enrolled subjects: ${response.statusText}`
          )
        }

        const data = await response.json()
        setEnrolledSubjects(data.enrolledSubjects)
      } catch (error) {
        console.error('Failed to fetch enrolled subjects:', error)
      }
    }

    fetchEnrolledSubjects()
  }, [])

  return (
    <>
      <div className="flex space-x-2">
        {enrolledSubjects.includes(SUBJECTS.MATH) && (
          <CreditCounter
            totalCredits={totalMathCredits}
            subject={SUBJECTS.MATH}
          />
        )}
        {enrolledSubjects.includes(SUBJECTS.CODING) && (
          <CreditCounter
            totalCredits={totalCodingCredits}
            subject={SUBJECTS.CODING}
          />
        )}
      </div>
    </>
  )
}

export default CreditsDisplay
